// Indique aux composants qu'ils sont affichés sous l'en-tête général de SOGAS RH (Layout).
import { createContext } from 'react';

export const EnteteGlobaleContext = createContext(false);
